import { CalloutVariant } from './Callout';
import { Theme, css } from '@emotion/react';

/**
 * Sets shape of a callout
 */
export const calloutBase = ({ borderRadius }: Theme) => {
  return css`
    border-radius: ${borderRadius[100]};
    border-style: solid;
    border-width: 1px;
  `;
};

const getVariant = (colors: Theme['colors'], variant: CalloutVariant) => {
  switch (variant) {
    case 'primary':
      return css`
        --callout-background-color: ${colors.bgPrimaryLighter};
        --callout-border-color: ${colors.borderPrimaryLight};
        --callout-link-color: ${colors.fgPrimaryDark};
      `;
    case 'internal':
      return css`
        --callout-background-color: ${colors.bgInternalLighter};
        --callout-border-color: ${colors.borderInternalLight};
        --callout-link-color: ${colors.fgInternalDark};
      `;
    case 'danger':
      return css`
        --callout-background-color: ${colors.bgDangerLighter};
        --callout-border-color: ${colors.borderDangerLight};
        --callout-link-color: ${colors.fgDangerDark};
      `;
    case 'success':
      return css`
        --callout-background-color: ${colors.bgSuccessLighter};
        --callout-border-color: ${colors.borderSuccessLight};
        --callout-link-color: ${colors.fgSuccessDark};
      `;
    case 'subtle':
      return css`
        --callout-background-color: ${colors.bgLighter};
        --callout-border-color: ${colors.borderDefault};
        --callout-link-color: ${colors.fgDefault};
      `;
    case 'warning':
      return css`
        --callout-background-color: ${colors.bgWarningLighter};
        --callout-border-color: ${colors.borderWarningLight};
        --callout-link-color: ${colors.fgWarningDark};
      `;
    case 'featureGate':
      return css`
        --callout-background-color: ${colors.bgFeatureGateLighter};
        --callout-border-color: ${colors.borderFeatureGateLight};
        --callout-link-color: ${colors.fgFeatureGateDark};
      `;
  }
};

/**
 * Determines background and border colors based on light/dark mode and variant.
 */
export const calloutVariant = ({ colors }: Theme, variant: CalloutVariant) => {
  const calloutVariantVars = getVariant(colors, variant);

  return css`
    ${calloutVariantVars};

    background-color: var(--callout-background-color);
    border-color: var(--callout-border-color);

    a:not(.MuiButton-root) {
      color: var(--callout-link-color);
    }
  `;
};

/**
 * Determines padding applied to the callout content
 */
export const calloutPadding = ({ spacing }: Theme, isDense: boolean) => {
  return isDense
    ? css`
        padding: ${spacing(1)}px ${spacing(1.5)}px;
      `
    : css`
        padding: ${spacing(2)}px;
      `;
};
